import { render } from "./user-index.vue?vue&type=template&id=13fb4c95&ts=true"
import script from "./user-index.vue?vue&type=script&lang=ts"
export * from "./user-index.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-base-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__